import type { RouteRecordRaw } from 'vue-router';

/** Маршрут карты мониторинга/симуляции; подключается в router.ts через barrel. */
export const geoMonitorRoutes: RouteRecordRaw[] = [
  { path: '/geolocation', name: 'geolocation', component: () => import('./GeolocationPage.vue') },
];
